import { render } from "./ExibGeralDash.vue?vue&type=template&id=32996e67&scoped=true"
import script from "./ExibGeralDash.vue?vue&type=script&lang=js"
export * from "./ExibGeralDash.vue?vue&type=script&lang=js"

import "./ExibGeralDash.vue?vue&type=style&index=0&id=32996e67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32996e67"]])

export default __exports__